import {Helmet} from "react-helmet-async";

const SITE_NAME = "Гранітна Майстерня";
const SITE_DOMAIN = "https://www.kamenyazh.com.ua";
const DEFAULT_OG_IMAGE = "/og-image.jpg";

export default function SEOMeta({title, description, canonicalPath = "/", ogImage}) {
	const fullTitle = `${title} | ${SITE_NAME}`;
	const canonicalUrl = `${SITE_DOMAIN}${canonicalPath}`;
	const image = ogImage || `${SITE_DOMAIN}${DEFAULT_OG_IMAGE}`;

	return (
		<Helmet>
			<title>{fullTitle}</title>
			<meta name="description" content={description} />
			<link rel="canonical" href={canonicalUrl} />

			<meta property="og:type" content="website" />
			<meta property="og:title" content={fullTitle} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:image" content={image} />
			<meta property="og:image:width" content="1200" />
			<meta property="og:image:height" content="630" />
			<meta property="og:locale" content="uk_UA" />
			<meta property="og:site_name" content={SITE_NAME} />
		</Helmet>
	);
}
